import { render, staticRenderFns } from "./ZoneObservation.vue?vue&type=template&id=20997918&"
import script from "./ZoneObservation.vue?vue&type=script&lang=js&"
export * from "./ZoneObservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports